export default {
  toastr: {
    cloud_license: {
      update_error_internal_use: 'No se ha podido realizar el cambio para uso interno'
    },
    create_error: 'Ocurrió un error al crear {{model}}. Corrija los errores e intente nuevamente',
    create_error_default: 'Ocurrió un error al crear {{model}}.',
    create_successful: '{{model}} se creó correctamente',
    delete_error: 'Ocurrió un error al eliminar {{model}}',
    delete_successful: '{{model}} se eliminó con exito',
    cancel_successful: '{{model}} se canceló con exito',
    unauthorized_successful: '{{model}} se desautorizó con exito',
    auth_successful: '{{model}} se autorizó con exito',
    link_successful: '{{model}} se vinculó con exito',
    update_onu_successful: '{{model}} se actualizó correctamente',
    change_password_successful: 'La contraseña se actualizó correctamente',
    change_ssid_successful: 'El SSID se actualizó correctamente',
    errors: {
      invalid: 'Algo salió mal, por favor contacte con soporte'
    },
    form_has_errors: 'Hay errores en el formulario. Corrija los errores e intente nuevamente.',
    news_notification: {
      publish: 'La novedad se envió a publicar correctamente'
    },
    sent_successfully: '{{model}} se envió correctamente',
    service_invoice: {
      generate_service_invoice: {
        success: {
          header: 'Factura periodica',
          body: 'Se genero exitosamente la factura periodica'
        }
      },
      cancel_initial_invoice: {
        success: {
          header: 'Factura inicial',
          body: 'No se volverá a mostrar el mensaje de generación de factura inicial'
        }
      }
    },
    subscription: {
      create_subscription: 'Suscripción correcta',
      subscription_cancelled: 'Suscripción cancelada'
    },
    uniq_code_numeric: {
      assign_successful: 'CUN asignado correctamente',
      create_successful: 'El formato CUN se creó correctamente',
      delete_successful: 'El formato CUN se eliminó con exito',
      update_successful: 'El formato CUN se actualizó correctamente'
    },
    update_error: 'Ocurrió un error al actualizar {{model}}. Corrija los errores e intente nuevamente',
    update_successful: '{{model}} se actualizó correctamente',
    verifying_model: 'Verificando {{model}}'
  }
};
